import { ReactElement } from "react";
import {
  DefaultModule,
  // IContentAreaProps,
  // IDataContext,
  IIndicator,
  IMenuButton,
  IndicatorType, IQueryController,
  ISelectedNode,
  IViewController, Modules
} from "../types";
import getStore from "../system/store";
import { simpleFetch } from "../system/useFetch";
import { IDashboard } from "./dashboardRT/types";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ProductionModule from "./production/module";
import ReportsModule from "./reports/module";
import MeltShopModule from "./meltShop/module";
import InterruptionsModule from "./interruptions/module";
import AlarmsModule from "./alarms/module";
import GeneralModule from "./general/module";
import MillModule from "./mill/module";
import DashboardRTModule from "./dashboardRT/module";
import ConfigModule from "./config/module";
import QAModule from "./qa/module";


const ModuleList: Record<DefaultModule, any> = {
  production: ProductionModule,
  reports: ReportsModule,
  meltShop: MeltShopModule,
  interruptions: InterruptionsModule,
  alarms: AlarmsModule,
  general: GeneralModule,
  mill: MillModule,
  dashboardRT: DashboardRTModule,
  config: ConfigModule,
  qa: QAModule
};

class MainModule {

  private instances: IViewController[] = [];

  constructor() {
    this.initModules().then(() => console.log("MainModule initialized"));
  }

  public async getController<T>(module:DefaultModule | null = null): Promise<T | null> {
    const { dataContext } = getStore().getState();

    if (!module && !dataContext) {

      return Promise.resolve(null);
    }

    return Promise.resolve(module
        ? ModuleList[module]
        : ModuleList[dataContext!.module!] ?? null);
  }

  public async getButtons (selectedNode: ISelectedNode | null, kiosk: boolean): Promise<IMenuButton[]> {
    return new Promise(resolve => {
      const result: IMenuButton[] = [];

      if (selectedNode) {
        if (kiosk) {
          simpleFetch<IDashboard[]>({
            module: "dashboard",
            query: "getDashboards",
            payload: {
              nodeID: selectedNode.nodeID,
              nodeType: selectedNode.type,
              moduleID: Modules.DASHBOARD_RT,
              rtModule: true
            }
          }).then(dashboards => {
            dashboards.forEach(dashboard => {
              result.push({
                title: dashboard.name,
                icon: <DashboardIcon/>,
                color: "cyan",
                dataContext: {
                  title: dashboard.name,
                  module: "dashboardRT",
                  subModule: "dashboardRT",
                  flag: "RT-DASHBOARD",
                  data: dashboard
                }
              });
            });

            resolve(result);
          });
        } else {
          selectedNode.menu.sort((a, b) => a.sortIndex - b.sortIndex).forEach(x => {
            const module = this.instances.find(m => m.getModuleName() === x.module);

            if (module) {
              const button = module.getButton(x.subModule, selectedNode);
              if (button) {
                button.dataContext.flag = x.flag;
                if (button.children) {
                  button.children.forEach(y => y.dataContext.flag = x.flag);
                }

                result.push(button);
              }
            }
          });

          resolve(result);
        }
      }
    });
  }

  public getIndicators (selectedNode: ISelectedNode, type: IndicatorType): ReactElement[] {
    const result: ReactElement[] = [];

    selectedNode.indicator.filter(y => y.type === type).forEach((x) => {
      const module = this.instances.find(m => m.getModuleName() === x.module);
      if (module) {
        const indicator = module.getIndicator(x);
        if (indicator) {
          result.push(indicator);
        }
      }
    });

    return result;
  }

  public getIndicator (indicator: IIndicator): ReactElement | null {
    if (indicator) {
      const module = this.instances.find(m => m.getModuleName() === indicator.module);
      if (module) {
        const component = module.getIndicator(indicator);
        if (component) {
          return component;
        }
      }
    }

    return null;
  }

  // public async getView (dataContext: IDataContext | null, props: IContentAreaProps): Promise<ReactElement> {
  //   if (dataContext){
  //     const controller = await this.getController<IViewController>();
  //
  //     return controller.getView(dataContext, props);
  //   }
  //
  //   return <div/>;
  // }

  private async initModules () {
    const defaultModules: DefaultModule[] = [ "production", "reports", "meltShop", "interruptions", "alarms", "general", "mill", "dashboardRT", "config", "qa" ];

    for (const moduleName of defaultModules) {
      const instance = await this.getController<IViewController>(moduleName);

      if (instance) {
        this.instances.push( instance );
      }
    }
  }
}

const mainModule = new MainModule();

export default mainModule;
